import styled from 'styled-components';
import Column from 'components/Column';
import { H1 } from 'components/Typography';

export const HeaderVideo = styled.video`
  width: 100%;
  height: auto;
  align-self: flex-start;
  object-fit: fill;
`;

export const Title = styled(H1)`
  color: ${({ theme }) => theme.colors.white};
  position: absolute;

  @media (max-width: 800px) {
    font-size: 40px;
    line-height: 44px;
  }
`;

export const TextContainer = styled(Column)`
  max-width: 900px;
  margin: 0 auto;
  padding: 56px 24px 64px;
  text-align: center;
  gap: 20px;
`;
